import React from 'react';
import RoadAssistancePointingRight from '../../../assets/images/RoadAssistancePointingRight.svg';
import NAFSupport from '../../../assets/images/NAFSupport.svg';

export enum LoginModalImage {
  NafSupport = 'NafSupport',
  RoadAssistance = 'RoadAssistance',
}

export const LOGIN_MODAL_IMAGE_MAP: Record<LoginModalImage, React.FC<React.SVGProps<SVGSVGElement>>> = {
  [LoginModalImage.NafSupport]: NAFSupport,
  [LoginModalImage.RoadAssistance]: RoadAssistancePointingRight,
};
